export default __webpack_public_path__ + "static/media/image-work-personal-m@3x.47852cae.webp";